import { api } from './api';

export interface ListaPrecioItem {
  id: number;
  listaPrecioId: number;
  productoId?: number;
  varianteId?: number;
  price: number;
  isActive: boolean;
  producto?: {
    id: number;
    name: string;
    sku?: string;
    precioBase: number;
  };
  variante?: {
    id: number;
    name: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ListaPrecio {
  id: number;
  tenantId: number;
  name: string;
  isActive: boolean;
  items?: ListaPrecioItem[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ListaPrecioCreate {
  name: string;
  items?: Array<{
    productoId?: number;
    varianteId?: number;
    price: number;
  }>;
}

export interface ListaPrecioUpdate {
  name?: string;
  isActive?: boolean;
}

export interface ListaPrecioItemCreate {
  productoId?: number;
  varianteId?: number;
  price: number;
}

export interface ListaPrecioItemUpdate {
  price?: number;
  isActive?: boolean;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const listaPrecioService = {
  getAll: async (
    page = 1,
    limit = 20,
    isActive?: boolean
  ): Promise<PaginatedResponse<ListaPrecio>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (isActive !== undefined) params.append('isActive', isActive.toString());
    
    const response = await api.get<PaginatedResponse<ListaPrecio>>(`/listas-precios?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { lista: ListaPrecio } }> => {
    const response = await api.get<{ data: { lista: ListaPrecio } }>(`/listas-precios/${id}`);
    return response.data;
  },

  getPrecioProducto: async (
    listaPrecioId: number,
    productoId?: number,
    varianteId?: number
  ): Promise<{ data: { price: number; fromList: boolean; listaPrecio?: string } }> => {
    const params = new URLSearchParams({
      listaPrecioId: listaPrecioId.toString()
    });
    if (productoId) params.append('productoId', productoId.toString());
    if (varianteId) params.append('varianteId', varianteId.toString());
    
    const response = await api.get<{ data: { price: number; fromList: boolean; listaPrecio?: string } }>(`/listas-precios/precio?${params}`);
    return response.data;
  },

  create: async (data: ListaPrecioCreate): Promise<{ data: { lista: ListaPrecio } }> => {
    const response = await api.post<{ data: { lista: ListaPrecio } }>('/listas-precios', data);
    return response.data;
  },

  update: async (id: number, data: ListaPrecioUpdate): Promise<{ data: { lista: ListaPrecio } }> => {
    const response = await api.put<{ data: { lista: ListaPrecio } }>(`/listas-precios/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/listas-precios/${id}`);
    return response.data;
  },

  addItem: async (id: number, data: ListaPrecioItemCreate): Promise<{ data: { item: ListaPrecioItem } }> => {
    const response = await api.post<{ data: { item: ListaPrecioItem } }>(`/listas-precios/${id}/items`, data);
    return response.data;
  },

  updateItem: async (id: number, itemId: number, data: ListaPrecioItemUpdate): Promise<{ data: { item: ListaPrecioItem } }> => {
    const response = await api.put<{ data: { item: ListaPrecioItem } }>(`/listas-precios/${id}/items/${itemId}`, data);
    return response.data;
  },

  deleteItem: async (id: number, itemId: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/listas-precios/${id}/items/${itemId}`);
    return response.data;
  }
};

